import { connect } from 'react-redux';
import { compose } from 'redux'
import { withFirebase } from '../Firebase';
import { withAxios } from '../api';
import { setViewState } from '../../actions';

import Viewer from './Viewer';

const mapState = ({ firebaseReducer, viewStateReducer }) => ({
  user: firebaseReducer.user,
  viewState: viewStateReducer,
})

export default compose(
  withFirebase,
  withAxios,
  connect(
    mapState,
    {setViewState}
  ))(Viewer)

